import { render, staticRenderFns } from "./CtaNoPhotosBought.vue?vue&type=template&id=c898f82c&scoped=true"
import script from "./CtaNoPhotosBought.vue?vue&type=script&lang=js"
export * from "./CtaNoPhotosBought.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c898f82c",
  null
  
)

export default component.exports